import React from "react";
import {Icon, Popup} from "semantic-ui-react";

const FormPopupHelper = (content) => (
    <Popup content={content} trigger={<Icon name='question circle outline' />} />
)
export default FormPopupHelper